<ng-container *ngIf="!editMode" header>
    <ham-page-header [title]="pageHeader.value | i18next" [backButtonRoute]="['../overview']"></ham-page-header>
</ng-container>
<ng-container content>
    <div class="banner" *ngIf="!activeCompany?.active">
        <!-- Icon -->
        <span class="ham-icon icon">
            <i class="exclamation-outline-icon"></i>
        </span>

        <!-- Text -->
        <div class="banner-text">{{ 'aumico_companies_inactivate_banner_text' | i18next }}</div>
    </div>
    <div class="page-buttons-fixed">
        <ham-button
            icon="assets/hamIcons/trash-outline.svg"
            type="submit"
            size="lg"
            outline="true"
            (buttonClick)="deleteCompany()"
        >
            {{ 'aumico_companies_delete_dialog_ok' | i18next }}
        </ham-button>
        <ham-button
            icon="assets/hamIcons/moon-outline.svg"
            type="submit"
            size="lg"
            variant="red"
            outline="true"
            *ngIf="activeCompany?.active"
            (buttonClick)="changeStatus(false)"
        >
            {{ 'aumico_companies_inactivate_button' | i18next }}
        </ham-button>
        <ham-button icon="assets/hamIcons/floppy-outline.svg" type="submit" size="lg" (buttonClick)="saveAndStay()">
            {{ 'aumico_button_save' | i18next }}
        </ham-button>
    </div>
    <div style="padding: 0">
        <aumico-edit-company-component
            [legalFormOptions]="shortLegalForms$ | async"
            [originalLegalFormOptions]="originalLegalForms"
            [countryOptions]="countries"
            [industryOptions]="industryOptions"
            [currentLanguage]="currentLanguage"
            [defaultLanguage]="defaultLanguage"
            [proceedButtonEvent$]="proceedButtonEvent$"
            [save$]="saveCompany.asObservable()"
            [defaultCountry]="defaultCountry"
            [activeCompany]="activeCompany"
            [canManageFx]="(canManageFx$ | async) ?? false"
            [organizationUsers]="organizationUsers$ | async"
            [assignedUser]="assignedUser$ | async"
            [clerkUser]="clerkUser$ | async"
            [deleteInProgress]="isDeleteInProgress"
            (createdCompany)="setCreatedCompany($event)"
            (isFormValid)="enableProceedButton($event)"
            (error)="handleErrors($event)"
            (fileUploaded)="onLogoUploaded($event)"
            (countrySelectionChange)="onCountrySelectionChange($event)"
            (deletingStateChange)="onDeletingStateChange($event)"
            [logo]="uploadedFile"
            [workflowOptions]="workflows"
            [organizationHasCpmmActive]="organizationHasCpmmActive"
            [organizationHasMandateAndTaskManagementEnabled]="organizationHasMandateAndTaskManagementEnabled"
        ></aumico-edit-company-component>
    </div>
</ng-container>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showDeleteConfirmationDialog"
    (cancel)="onDeleteConfirmationDialogClosed(false)"
    (action)="onDeleteConfirmationDialogClosed(true)"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_companies_delete_dialog_ok' | i18next }}"
    noActionBtnText="{{ 'aumico_companies_delete_dialog_cancel' | i18next }}"
>
    <div class="modal-content">
        <span hamIconShapes icon="assets/hamIcons/trash-outline.svg" variant="red" size="lg" type="square"></span>
        <div>
            <p class="title" [innerHTML]="'aumico_companies_delete_dialog_text_1' | i18next"></p>
            <p class="light">{{ 'aumico_companies_delete_dialog_text_2' | i18next }}</p>
        </div>
    </div>
</ham-confirm-decline-modal>
<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showDisableConfirmationDialog"
    (cancel)="onDisableConfirmationDialogClosed(false)"
    (action)="onDisableConfirmationDialogClosed(true)"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_companies_inactivate_dialog_ok' | i18next }}"
    noActionBtnText="{{ 'aumico_companies_inactivate_dialog_cancel' | i18next }}"
>
    <div class="modal-content">
        <span hamIconShapes icon="assets/hamIcons/trash-outline.svg" variant="red" size="lg" type="square"></span>
        <div>
            <p class="title" [innerHTML]="'aumico_companies_inactivate_dialog_text_1' | i18next"></p>
            <p class="light">{{ 'aumico_companies_inactivate_dialog_text_2' | i18next }}</p>
        </div>
    </div>
</ham-confirm-decline-modal>
